import React, { useState, useContext, useEffect } from "react";
import { auth, firestore, storage } from "./firebase";
import { useNavigate } from "react-router-dom";
import Geocode from "react-geocode";
import axios from "axios";

export const DataContext = React.createContext();
export const useData = () => useContext(DataContext);
export const DataProvider = ({ children, ...initOptions }) => {
    const [authError, setAuthError] = useState(null);
    const [registerError, setRegisterError] = useState(null);

    const [success, setSuccess] = useState(null);
    const [jobs, setJobs] = useState(null);
    const [loading, setIsLoading] = useState(true);
    const [unternehmen, setUnternehmen] = useState(null);
    const [experte, setExperte] = useState(null);
    const [companyLogo, setCompanyLogo] = useState(null);
    const [profilePicture, setProfilePicture] = useState(null);

    const [submitError, setSubmitError] = useState(false);

    const navigate = useNavigate();

    const [user, setUser] = useState();
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUser(user);
        });
    }, []);

    const assetUrl =
        process.env.NODE_ENV === "development"
            ? ""
            : "/wp-content/uploads/reactapps/app-1281";

    useEffect(() => {
        if (user?.uid) {
            const subscriber = firestore
                .collection("unternehmen")
                .where("user", "==", user.uid)
                .onSnapshot((querySnapshot) => {
                    if (!querySnapshot.empty) {
                        const doc = querySnapshot.docs[0];
                        const update = {
                            id: doc.id,
                            ...doc.data(),
                        };
                        if (update.logo) {
                            storage
                                .ref(update.logo)
                                .getDownloadURL()
                                .then((url) => {
                                    setCompanyLogo(url);
                                });
                        }
                        setUnternehmen(update);
                    }
                    return () => subscriber();
                });
            const subscriber2 = firestore
                .collection("experten")
                .where("user", "==", user.uid)
                .onSnapshot((querySnapshot) => {
                    if (!querySnapshot.empty) {
                        const doc = querySnapshot.docs[0];
                        const update = {
                            id: doc.id,
                            ...doc.data(),
                        };
                        if (update.image) {
                            storage
                                .ref(update.image)
                                .getDownloadURL()
                                .then((url) => {
                                    setProfilePicture(url);
                                });
                        }
                        setExperte(update);
                    }
                    return () => subscriber2();
                });
        }
    }, [user]);

    const signIn = ({ email, password }) => {
        setAuthError(null);
        auth.signInWithEmailAndPassword(email, password)
            .then((user) => {})
            .catch((error) => {
                setAuthError("Die Daten sind nicht korrekt.");
            });
    };

    const signOut = (e) => {
        auth.signOut();
        navigate("/");
    };

    const changePassword = ({ password, repeat }) => {
        setSuccess(null);
        setAuthError(null);
        if (password !== repeat) {
            return setAuthError("Passwörter stimmen nicht überein.");
        }
        auth.currentUser
            .updatePassword(password)
            .then(function () {
                setSuccess("Passwort geändert.");
            })
            .catch(function (error) {
                setAuthError(error.message);
            });
    };

    const resetPassword = (email) => {
        setSuccess(null);
        setAuthError(null);
        auth.sendPasswordResetEmail(email)
            .then(function () {
                setSuccess(
                    "Die E-Mail zum Zurücksetzen Ihres Passworts wurde versendet"
                );
            })
            .catch(function (error) {
                setAuthError(error.message);
            });
    };

    const signUp = (email, password) => {
        auth.createUserWithEmailAndPassword(email, password)
            .then((userCredential) => {
                userCredential.user.sendEmailVerification();
                setUser(userCredential);
            })
            .catch((error) => {
                switch (error.message) {
                    case "Firebase: Password should be at least 6 characters (auth/weak-password).":
                        setRegisterError(
                            "Passwort ist zu schwach. Bitte mindestens 6 Buchstaben geben."
                        );
                        break;
                    case "Firebase: The email address is already in use by another account. (auth/email-already-in-use).":
                        setRegisterError("E-Mail Adresse ist schon benutzt");
                        break;
                    default:
                        setRegisterError("Es ist ein Fehler aufgetreten.");
                        break;
                }
            });
    };

    const createCompany = (values, setPage) => {
        setSubmitError(null);
        axios
            .get(
                "https://nominatim.openstreetmap.org/search?street=" +
                    values.street_number +
                    "&city=" +
                    values.city +
                    "&postalcode=" +
                    values.zip +
                    "&format=json"
            )
            .then((response) => {
                if (response?.data) {
                    const location = {
                        lat: response.data[0].lat,
                        lng: response.data[0].lon,
                    };
                    console.log(location);
                    if (!unternehmen) {
                        firestore
                            .collection("unternehmen")
                            .add({ ...values, location: location })
                            .then((doc) => {
                                setPage("finish");
                            })
                            .catch((error) => setSubmitError(error.message));
                    } else {
                        firestore
                            .collection("unternehmen")
                            .doc(values.id)
                            .set({ ...values, location: location })
                            .then((doc) => {
                                setPage("finish-save");
                            })
                            .catch((error) => setSubmitError(error.message));
                    }
                }
            })
            .catch((error) => {
                setSubmitError("Ihre Adresse konnte nicht verifiziert werden.");
            });
    };

    const createExpert = (values, setPage) => {
        setSubmitError(null);
        axios
            .get(
                "https://nominatim.openstreetmap.org/search?street=" +
                    values.street_number +
                    "&city=" +
                    values.city +
                    "&postalcode=" +
                    values.zip +
                    "&format=json"
            )
            .then((response) => {
                console.log(response?.data);
                if (response?.data) {
                    const location = {
                        lat: response.data[0].lat,
                        lng: response.data[0].lon,
                    };
                    if (!experte) {
                        firestore
                            .collection("experten")
                            .add({ ...values, location: location })
                            .then((doc) => {
                                setPage("finish");
                            })
                            .catch((error) => setSubmitError(error.message));
                    } else {
                        firestore
                            .collection("experten")
                            .doc(values.id)
                            .set({ ...values, location: location })
                            .then((doc) => {
                                setPage("finish-save");
                            })
                            .catch((error) => setSubmitError(error.message));
                    }
                }
            })
            .catch((error) =>
                setSubmitError("Ihre Adresse konnte nicht verifiziert werden.")
            );
    };

    const exports = {
        user,
        signIn,
        signOut,
        signUp,
        authError,
        setAuthError,
        success,
        resetPassword,
        changePassword,
        jobs,
        unternehmen,
        experte,
        companyLogo,
        createCompany,
        createExpert,
        profilePicture,
        registerError,
        submitError,
        assetUrl,
        setUnternehmen,
        submitError,
        setSubmitError,
    };

    return (
        <DataContext.Provider value={exports}>{children}</DataContext.Provider>
    );
};
